import gql from 'graphql-tag'

export const MUTATION_UPSERT_AHUB_REPORT_ANALYTICS = gql`
  mutation UpsertAHubReportAnalytics($input: UpsertAHubReportAnalyticsInput!) {
    upsertAHubReportAnalytics(input: $input) {
      createdAt
      error
      id
      status
      updatedAt
    }
  }
`

export const MUTATION_ACTIVE_DELETE_AHUB_REPORT_ANALYTICS = gql`
  mutation ActiveDeleteAHubReportAnalytics($input: ActiveDeleteAHubReportAnalyticsInput!) {
    activeDeleteAHubReportAnalytics(input: $input)
  }
`

export const SUBSCRIPTION_DELETE_AHUB_REPORT_ANALYTICS =
  'subscription DeletedAHubReportAnalytics($roomId: String!) {\n  deletedAHubReportAnalytics(roomId: $roomId) {\n    status\n    messageError\n  }\n  }'

export const QUERY_ENTITIES_LINKED_BY_AHUB_CONFIGURATION = gql`
  query EntitiesLinkedByAhubConfiguration($input: EntitiesLinkedByAhubConfigurationInput!) {
    entitiesLinkedByAhubConfiguration(input: $input) {
      segments {
        id
        name
      }
      campaigns {
        chatbotPush {
          description
          id
          mode
          title
        }
        email {
          description
          id
          mode
          title
        }
        sms {
          description
          id
          mode
          title
        }
        whatsapp {
          description
          id
          mode
          title
        }
        push {
          description
          id
          mode
          title
        }
      }
      omniCampaigns {
        description
        id
        title
      }
      raffles {
        description
        id
        title
      }
    }
  }
`
export const QUERY_AHUB_ANALYTICS_LIMITS = gql`
  query AHubAnalyticsLimits {
    aHubAnalyticsLimits {
      rfv {
        notRecurrent {
          createdTotal
          limitTotal
        }
        recurrent {
          limitTotal
          createdTotal
        }
      }
      dre {
        notRecurrent {
          createdTotal
          limitTotal
        }
        recurrent {
          limitTotal
          createdTotal
        }
      }
    }
  }
`

export const QUERY_AHUB_ANALYTICS_CONFIGURATIONS = gql`
  query AHubAnalyticsConfigurations($type: aHubAnalyticsConfigurationType!) {
    aHubAnalyticsConfigurations(type: $type) {
      aHubAnalyticsConfigurations {
        notRecurrent {
          analyzedPeriod {
            initialDate
            finalDate
          }
          referencePeriod {
            initialDate
            finalDate
          }
        }
        recurrent {
          initialWeekDay
          modelType
        }
        status
        model
        type
        default
        processing
        createdAt
        filters {
          units {
            id_erp
            name
            _id
          }
          products {
            name
            sku
            _id
          }
          clientsType
          offersScheduleIds
        }
        title
        _id
      }
    }
  }
`
